<template>
    <div class="product-insights green-border-box">
      <div v-if="!loading">
        <h4 style="margin-left:15px;">State Campaigns</h4>
          <apexcharts :options="chartOptions" :series="series"></apexcharts>
      </div>
      <h4 v-else style="text-align: center;">Loading Statewise Insights...</h4>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ProductInsights',
  components: {
    apexcharts: VueApexCharts
  },
  props: ['brandId'],
  data: function () {
    return {
      loading: true,
      chartOptions: {
        chart: {
          title: {
            text: 'State Insights'
          },
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            borderRadius: 1,
            horizontal: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      series: [ {
        data: []
      }
      ]
    }
  },
  methods: {
    getStateInsights () {
      this.$store.dispatch('getBrandStateInsights', this.brandId)
        .then(
          (response) => {
            this.series[0].data = response.body
            this.loading = false
          }
        )
    }
  },

  mounted () {
    this.getStateInsights()
  },
  watch: {

  }
}
</script>
